import { render, staticRenderFns } from "./resolve-lack-amount.vue?vue&type=template&id=539776a2&scoped=true"
import script from "./resolve-lack-amount.vue?vue&type=script&lang=js"
export * from "./resolve-lack-amount.vue?vue&type=script&lang=js"
import style0 from "./resolve-lack-amount.vue?vue&type=style&index=0&id=539776a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539776a2",
  null
  
)

export default component.exports